const OrganisationTypeEnum = Object.freeze({
    ADVISER: 'ADVISER',
    INVESTOR: 'INVESTOR',
    BROKER: 'BROKER',
    COMPANY: 'COMPANY',
    CUSTODIAN: 'CUSTODIAN',
    FUND_MANAGER: 'FUND_MANAGER',
    NOMINEE: 'NOMINEE',
    PRODUCT_PROVIDER: 'PRODUCT_PROVIDER',
    RECEIVINGAGENT: 'RECEIVINGAGENT',
    REGISTRAR: 'REGISTRAR',
    GROWTH_INVEST: 'GROWTH_INVEST'
});

export default OrganisationTypeEnum;
